module.exports = __webpack_public_path__ + "img/down.c9e06319.png";